<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tit">CONTENTS</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction. A Nationals Medley: People, Places and Things</a></p>
<p class="toc1"><a href="#/part1"><b>Part I. A Prelude</b></a></p>
<p class="toc"><a href="#/ch1">Chapter 1. Basket Ball</a></p>
<p class="toc"><span href="#/ch2" title="Link target outside of Sample">Chapter 2. Syracuse Nationals, 1946–1949: The NBL Years</span></p>
<p class="toc1"><span href="#/part2" title="Link target outside of Sample"><b>Part II. The Syracuse Nationals</b></span></p>
<p class="toc"><span href="#/ch3" title="Link target outside of Sample">Chapter 3. The Franchise’s First Star, 1949–1954</span></p>
<p class="toc"><span href="#/ch4" title="Link target outside of Sample">Chapter 4. A Gut-Wrenching Championship, 1954–1955</span></p>
<p class="toc"><span href="#/ch5" title="Link target outside of Sample">Chapter 5. A Big-League Team in a Small Town, 1955–1959</span></p>
<p class="toc"><span href="#/ch6" title="Link target outside of Sample">Chapter 6. Nats Wilt after Chamberlain Arrives, 1959–1961</span></p>
<p class="toc"><span href="#/ch7" title="Link target outside of Sample">Chapter 7. The Sixties, 1961–1963</span></p>
<p class="toc"><span href="#/ch8" title="Link target outside of Sample">Chapter 8. A Cognitive Transition</span></p>
<p class="toc1"><span href="#/part3" title="Link target outside of Sample"><b>Part III. The Syracuse Legacy</b></span></p>
<p class="toc"><span href="#/ch9" title="Link target outside of Sample">Chapter 9. The 24-Second Clock</span></p>
<p class="toc"><span href="#/ch10" title="Link target outside of Sample">Chapter 10. The Calls from Springfield</span></p>
<p class="toc"><span href="#/ch11" title="Link target outside of Sample">Chapter 11. Professional Basketball, Syracuse Style</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8ce12094